import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4">
      <p className="text-4xl font-semibold text-gray-300">404</p>
      <p className="text-gray-500">Page not found</p>
      <Link to="/chat" className="text-sm text-blue-600 hover:underline">
        Go to chat
      </Link>
    </div>
  );
}
